module.exports = __webpack_public_path__ + "static/media/avatar_25.6da7fd4e.svg";